<template>
  <div class="header__ct">
      <div class="arrow-container">
        <div class="arrow arrow--left" @click="handleBack()" title="Previous step" v-bind:class="{ unvisible: !showLeftArrow }">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="451.847px" height="451.847px" viewBox="0 0 451.847 451.847" style="enable-background:new 0 0 451.847 451.847;"
            xml:space="preserve">
            <g>
              <path d="M97.141,225.92c0-8.095,3.091-16.192,9.259-22.366L300.689,9.27c12.359-12.359,32.397-12.359,44.751,0
                c12.354,12.354,12.354,32.388,0,44.748L173.525,225.92l171.903,171.909c12.354,12.354,12.354,32.391,0,44.744
                c-12.354,12.365-32.386,12.365-44.745,0l-194.29-194.281C100.226,242.115,97.141,234.018,97.141,225.92z"/>
            </g>
          </svg>
        </div>
      </div>
      <div class="main-ct">
        <span v-for="step in steps" :key="step.index">
            <span v-if="assessment.step == step" class="active-step"><span class="title">{{step.title}}</span><span class="short-title">{{step.shortTitle}}</span></span>
          <span v-else-if="assessment.step.index == 0"><span class="title">{{step.title}}</span><span class="short-title">{{step.shortTitle}}</span></span>
          <button v-else="" class="btn-step" @click="assessment.setStep(step)"><span class="title">{{step.title}}</span><span class="short-title">{{step.shortTitle}}</span></button>
          <span v-if="step.index < 3" class="separator">
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   width="451.846px" height="451.847px" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;"
                   xml:space="preserve">
            <g>
              <path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
                L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
                c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/>
            </g>
          </svg>
          </span>
        </span>
      </div>
      <div class="arrow-container">
        <div class="arrow arrow--right" @click="handleNext()" title="Next step" v-bind:class="{ unvisible: !showRightArrow }">
          <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="451.846px" height="451.847px" viewBox="0 0 451.846 451.847" style="enable-background:new 0 0 451.846 451.847;"
            xml:space="preserve">
            <g>
              <path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
                L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
                c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/>
            </g>
          </svg>
        </div>
      </div>
  </div>
</template>

<script>
import { assessment, steps } from '@/services/assessment-model.js'
export default {
  name: 'Header',
  data() {
    return {
      assessment: assessment,
      steps: steps
    }
  },
  methods: {
    handleNext: function() {
      assessment.nextStep();
    },
    handleBack: function() {
       assessment.previousStep();
    }
  },
  mounted() {
  },
  computed: {
    showLeftArrow: function() {
      return assessment.step !== steps[0]
    },
    showRightArrow: function() {
      return assessment.step !== steps[0] && assessment.step !== steps[3]
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
    &__ct {
        display: flex;
        height: 60px;
        background-color: #009bd1;
        .arrow-container {
            width: 85px;
            padding: 10px;
            .arrow {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
                border-radius: 20px;
                background-color: #ffffff;
                cursor: pointer;
                transition: all 0.4s;
                svg {
                    fill: #009bd1;
                    width: 25px;
                    height: 25px;
                    border: 2px solid #009bd1;
                    padding: 5px;
                    border-radius: 50%;
                }
            }
            .arrow:hover {
                width: calc(100% + 10px);
            }
            .arrow--left:hover {
                margin-left: -10px;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
            .arrow--right:hover {
                margin-right: -10px;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }
    }
}

.main-ct {
    margin: auto;
    font-family: "rubrikregular";
    font-size: 22px;
    line-height: 23px;
    color: rgba(255, 255, 255, 0.5);

    .title {
        display: inline-block;
        @media (max-width: 850px){
            display: none;
        }
    }
    .short-title {
        display: none;
        @media (max-width: 850px){
            display: inline-block;
        }
    }

    .active-step {
        color: #fff;
    }

    .btn-step {
        border: inherit;
        padding: inherit;
        color: inherit;
        background: none;
    }

    .btn-step:hover {
        color: #fff;
        text-decoration: underline;
    }

    .separator {
        margin: 0 10px;
        svg {
            width: 16px;
            height: 16px;
            fill: rgba(255, 255, 255, 0.5);
        }
    }
}

.unvisible {
    visibility: hidden;
}
</style>
